import React, { useState } from "react";

import date from "date-and-time";

import QuickForm from "components/Meta/QuickForm";
import TimeLine from "./TimeLine";
import QuickTable from "components/Meta/QuickTable";
import BoardHeader from "components/Meta/BoardHeader";

function ListSales({ ctxView, viewType, onChangeView }) {
  const today = date.format(
    date.addHours(new Date(), -12, true),
    "YYYY-MM-DD HH:mm:ss",
  );

  const domain = [
    ["create_date", ">=", today],
    [
      "order_status",
      "in",
      [
        "draft",
        "commanded",
        "in_preparation",
        "dispatched",
        "requested",
        "delivered",
      ],
    ],
  ];
  const [filter, setFilter] = useState(domain);

  async function handleFilter(domain) {
    setFilter(domain);
  }

  return (
    <div className="mt-4">
      {viewType === "list" ? (
        <>
          <BoardHeader
            ctxView={ctxView}
            viewType={viewType}
            handleFilter={handleFilter}
          />
          <QuickTable
            onChangeView={onChangeView}
            ctxView={ctxView}
            domain={filter}
          />
        </>
      ) : (
        <>
          <TimeLine />
          <QuickForm
            level={"main"}
            ctxView={ctxView}
            onChangeView={onChangeView}
          />
        </>
      )}
    </div>
  );
}

export default ListSales;
